import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { plainToClass } from 'class-transformer';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map, tap, timeout } from 'rxjs/operators';
import { RestService } from 'src/app/shared/service/rest.service';
import { QualificationAggregate } from '../model/qualification-aggregate';
import { TenantInfo } from '../model/tenant-info';
import { SessionStorageService } from '../../common/service/session-storage.service';
import { SakpModuleUtils } from '../sakp-module-utils';


@Injectable()
export class QualificationService extends RestService {
    public static readonly SOURCE = 'qualifications';
    private static readonly STORAGE_NAME = 'sakp-qualifications';
    private dataSubject: BehaviorSubject<QualificationAggregate[]> = new BehaviorSubject([]);

    constructor(http: HttpClient, private sessionStorageService: SessionStorageService) {
        super(http);
        this.serverUrl = SakpModuleUtils.getSakpServerUrl();
        const data = this.sessionStorageService.getItemArray<QualificationAggregate>(QualificationService.STORAGE_NAME, QualificationAggregate);
        if (data != null)
            this.dataSubject.next(data);

    }

    initiate(tenant: TenantInfo): Observable<QualificationAggregate[]> {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        return this.doGet('api/v1/dict/qualifications', null, { 'X-Tenant-ID': tenant.id.toString() })
            .pipe(
                timeout(5000),
                map((res: any[]) => plainToClass(QualificationAggregate, res)),
                map(res => res.sort((a, b) => a.since.getTime() - b.since.getTime())),
                tap(res => {
                    this.dataSubject.next(res);
                    this.sessionStorageService.setItem(QualificationService.STORAGE_NAME, res);
                }),
                catchError(err => {
                    this.dataSubject.next([]);
                    this.sessionStorageService.setItem(QualificationService.STORAGE_NAME, []);
                    err.source = QualificationService.SOURCE;
                    return throwError(err);
                })
            );
    }

    getAll(): QualificationAggregate[] {
        return this.dataSubject.getValue() || [];
    }

    getByDate(date: Date): QualificationAggregate | null {
        return this.getAll().find(q => q.since <= date && (q.until == null || q.until > date)) || null;
    }

    clear(): void {
        this.sessionStorageService.setItem(QualificationService.STORAGE_NAME, []);
        this.dataSubject.next([]);
    }

}
